const SITE_DATA = {
  ANF: {
    timezone: 'America/Sao_Paulo',
    lang: 'pt',
    locale: 'pt_BR',
  },
  BVP: {
    timezone: 'UTC',
    lang: 'es',
    locale: 'es_LA',
  },
  AME: {
    timezone: 'America/Mexico_City',
    lang: 'es',
    locale: 'es_LA',
  },
  BAR: {
    timezone: 'America/Argentina/Buenos_Aires',
    lang: 'es',
    locale: 'es_AR',
  },
  BGM: {
    timezone: 'UTC',
    lang: 'es',
    locale: 'es_LA',
  },
  BBR: {
    timezone: 'America/Sao_Paulo',
    lang: 'pt',
    locale: 'pt_BR',
  },
  CHI: {
    timezone: 'UTC',
    lang: 'es',
    locale: 'es_LA',
  },
  BCL: {
    timezone: 'America/Santiago',
    lang: 'es',
    locale: 'es_LA',
  },
  BCO: {
    timezone: 'America/Bogota',
    lang: 'es',
    locale: 'es_CO',
  },
  VLT: {
    timezone: 'America/Guayaquil',
    lang: 'es',
    locale: 'es_LA',
  },
  BUS: {
    timezone: 'America/New_York',
    lang: 'en',
    locale: 'en_US',
  },
  BMX: {
    timezone: 'America/Mexico_City',
    lang: 'es',
    locale: 'es_MX',
  },
  BPE: {
    timezone: 'America/Lima',
    lang: 'es',
    locale: 'es_LA',
  },
  PUM: {
    timezone: 'America/Mexico_City',
    lang: 'es',
    locale: 'es_LA',
  },
  SPO: {
    timezone: 'UTC',
    lang: 'es',
    locale: 'es_LA',
  },
  BLA: {
    timezone: 'America/New_York',
    lang: 'es',
    locale: 'es_ES',
  },
  VCA: {
    timezone: 'America/Mexico_City',
    lang: 'es',
    locale: 'es_LA',
  },
  DLA: {
    timezone: 'America/Santiago',
    lang: 'es',
    locale: 'es_LA',
  },
  FCA: {
    timezone: 'America/Costa_Rica',
    lang: 'es',
    locale: 'es_LA',
  },
  JBB: {
    timezone: 'America/Mexico_City',
    lang: 'es',
    locale: 'es_LA',
  },
  JFB: {
    timezone: 'America/Mexico_City',
    lang: 'es',
    locale: 'es_LA',
  },
  LPM: {
    timezone: 'America/Argentina/Buenos_Aires',
    lang: 'es',
    locale: 'es_AR',
  },
  PBJ: {
    timezone: 'America/Argentina/Buenos_Aires',
    lang: 'es',
    locale: 'es_AR',
  },
  RDG: {
    timezone: 'America/Santiago',
    lang: 'es',
    locale: 'es_LA',
  },
  SFBR: {
    timezone: 'America/Sao_Paulo',
    lang: 'pt',
    locale: 'pt_BR',
  },
  SFES: {
    timezone: 'UTC',
    lang: 'es',
    locale: 'es_LA',
  },
  SPD: {
    timezone: 'UTC',
    lang: 'en',
    locale: 'en_US',
  },
  SPK: {
    timezone: 'UTC',
    lang: 'pt',
    locale: 'pt_BR',
  },
  WST: {
    timezone: 'America/New_York',
    lang: 'en',
    locale: 'en_US',
  },
}

export const getSiteData = (site = 'BAR') => SITE_DATA[site] || SITE_DATA.BVP
